import { piivoUiConfigKey } from 'piivo-ui/src';

import i18n from '../../../core/i18n';
import keys from './keys.json';

export const puiProvide = {
  [piivoUiConfigKey]: {
    $pui_t: puiKey => {
      const internalKey = keys[puiKey];
      return internalKey ? i18n.t(internalKey) : puiKey;
    },
  },
};
